interface CoinImageProps {
	height?: string | number;
	classes?: string;
	image: string;
	alt?: string;
}
/**
 * A React functional component that renders an image of a coin.
 *
 * @param {string} height - The height of the coin image (default: '25px').
 * @param {string} classes - Additional CSS classes to apply to the coin image.
 * @return {JSX.Element} The rendered coin image.
 */
export const TabImage: React.FC<CoinImageProps> = ({
	classes = '',
	image,
	alt,
}: CoinImageProps) => {
	/*********************
	// #region Template
	**********************/
	return <img src={image} alt={alt} className={`h-[25px] ${classes}`} />;
};
